import api from '@/shared/api/client';

// Le referentiel des codes postaux, demande AU SERVEUR et jamais recopie ici.
//
// La tentation etait d'embarquer une table dans le navigateur. Il en existait une,
// `shared/constants/regions.js`, RETIREE par le lot O une fois son dernier appelant
// (le wizard installateur) bascule sur cette route. Ne pas la reintroduire. Un
// decoupage sur les deux premiers chiffres du code postal se trompe de region sur
// 01590, 97133 et 97150, ne sait rien du departement (42620 est dans l'Allier, pas dans
// la Loire) et ne peut pas exprimer les 16 codes postaux a cheval sur deux
// departements. Deux referentiels finissent toujours par diverger, et celui qui se
// trompe le fait sans erreur visible.
//
// Le serveur repond depuis `app/data/codes_postaux.json` (base officielle La Poste),
// donc hors ligne de tout tiers : aucun appel a Energrid, dont la cle est vide en
// pre-production.
export async function lireCodePostal(codePostal) {
  const { data } = await api.get(`/geo/code-postal/${encodeURIComponent(codePostal)}`);
  return data;
}

// Vrai quand la saisie a la tete d'un code postal francais. Sert a ne PAS interroger le
// serveur a chaque frappe : « 9 », « 93 » et « 932 » ne peuvent rien designer.
export function ressembleAUnCodePostal(valeur) {
  return /^\d{5}$/.test(String(valeur || '').replace(/[\s.  ]/g, ''));
}

// DEUX ROUTES, UN SEUL SERVICE — le meme partage que la recherche de PDL
//
// Le canal QR n'a PAS de compte : ni le client final, ni le poseur sur son telephone.
// La route authentifiee y repondrait 403, et l'ecran verrait une liste vide sans savoir
// pourquoi. Le CRM et le wizard, eux, passent par la route authentifiee, dont le
// plafond compte par COMPTE -- sinon tout un bureau derriere une seule sortie internet
// partagerait le quota, et le quatrieme client saisi se ferait couper.
//
// Les deux appellent `adresses_ban.chercher` cote serveur : memes propositions, par
// construction.
const ROUTE_ADRESSES_PUBLIQUE = '/onboarding/adresses';
const ROUTE_ADRESSES_AUTHENTIFIEE = '/geo/adresses';

// ⚠️ LE DEFAUT EST « AUTHENTIFIE », ET C'EST DELIBERE — l'inverse du module PDL.
//
// Trois portes sur quatre sont derriere un compte. Surtout, les deux oublis possibles
// n'ont pas le meme prix : oublier `authentifie: false` sur une porte publique donne un
// 403 avale en liste vide, donc une proposition qui ne s'affiche pas -- visible en
// recette, sans consequence. Oublier `authentifie: true` sur une porte du CRM ferait
// compter par ADRESSE IP : tout un bureau partagerait 120 appels sur cinq minutes, et
// le collegue suivant se verrait couper sans rien avoir fait. On prefere l'oubli qui se
// voit tout de suite a celui qui se paie plus tard, sur quelqu'un d'autre.
export async function chercherAdresses(saisie, { authentifie = true } = {}) {
  const route = authentifie ? ROUTE_ADRESSES_AUTHENTIFIEE : ROUTE_ADRESSES_PUBLIQUE;
  const { data } = await api.get(route, { params: { q: saisie } });
  return data?.propositions || [];
}
